import { render, staticRenderFns } from "./bien-recu.vue?vue&type=template&id=2b50f05c&scoped=true&"
import script from "./bien-recu.vue?vue&type=script&lang=js&"
export * from "./bien-recu.vue?vue&type=script&lang=js&"
import style0 from "./bien-recu.vue?vue&type=style&index=0&id=2b50f05c&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b50f05c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/app/components/Logo.vue').default,FooterV2: require('/app/components/FooterV2.vue').default})
